/**
 * Is the calculator's lifestyle figure the one the spending planner produced?
 *
 * The link is one-way on purpose: "Use in calculator" copies the plan total
 * across, but moving the slider never rewrites the itemised plan. This says
 * which of the two the calculator is using, so the page can show it.
 */
export function usesSpendingPlan(
  spending: { lifestylePerYear: number; lifestylePricedLocally: boolean; cityId: string },
  plan: { annualTotal: number; cityId: string },
): boolean {
  return (
    spending.lifestylePricedLocally &&
    spending.cityId === plan.cityId &&
    Math.abs(spending.lifestylePerYear - Math.round(plan.annualTotal)) < 1
  );
}
